module.exports = __webpack_public_path__ + "img/1 (7).b7b83bd3.png";